import { useMutation, useQueryClient } from '@tanstack/react-query';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';

export const useCreateBusinessPlanFrom = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: BusinessPlanApi.createBusinessPlanFrom,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: businessPlanQueryKeys.businessPlans() });
      queryClient.invalidateQueries({ queryKey: businessPlanQueryKeys.businessPlansLimits() });
    },
  });
};
